export default __webpack_public_path__ + "assets/webgl/picking-4.9384ab3a.glb";